import '@vidstack/react/player/styles/base.css';
import { useState, type HTMLAttributes } from 'react';
import type { Artwork } from '~/api/types';
import type { SupportedLanguage } from '~/lib/i18n';
import '~/lib/player/player.css';
import { cn } from '~/lib/utils';
import ImagesCarousel from '../images/images-carousel';
import Player from '../player/player';
import ArtworkControls from './artwork-controls';
import { useArtworkMedia } from './media/useArtworkMedia';

interface Params {
  artwork: Artwork;
  lang: SupportedLanguage;
}

const ArtworkUI = ({
  artwork,
  lang,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement> & Params) => {
  const { title, info, artists } = artwork;
  const images = artwork.images.map(image => ({
    src: image.file,
    alt: image.alt_text[lang as SupportedLanguage] ?? title,
  }));
  // state
  const media = useArtworkMedia(artwork, lang);
  const [selectedMediaType, setSelectedMediaType] = useState(media.at(0)?.type);
  const selectedMedia = media.find(media => media.type === selectedMediaType);
  // UI
  // console.log(artwork);
  // console.log(media);
  // console.log(inView);
  return (
    <div
      id={artwork.id}
      className={cn('md:max-w-[640px] px-1 py-4 dark:bg-card', className)}
      {...props}
    >
      <p className="text-base text-primary">{title}</p>
      <p className="text-sm">{info}</p>
      {artists.length ? <p className="text-sm">{artists.join(', ')}</p> : null}
      <div className="mt-8">
        <ImagesCarousel images={images} />
      </div>
      <div className="flex mt-8">
        <ArtworkControls
          media={media}
          lang={lang}
          selectedMediaType={selectedMediaType}
          setSelectedMediaType={setSelectedMediaType}
        />
      </div>
      <div className="mt-8">
        {selectedMedia ? (
          <div>
            <Player src={selectedMedia.url} load="visible" />
            {selectedMedia.transcription ? (
              <p className="text-sm mt-6">{selectedMedia.transcription}</p>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};
ArtworkUI.displayName = 'ArtworkUI';
export default ArtworkUI;
